/**
 * Collection Product Reordering
 * This script reorders products in a collection based on URL query parameters
 */

class ProductGridReorder {
  constructor() {
    // Initialize on the product grid container
    this.container = document.querySelector('product-grid-container');
    if (!this.container) return;

    this.productGrid = this.container.querySelector('[id="data-pagination"]');
    if (!this.productGrid) return;

    // Get search query from URL
    const searchParams = new URLSearchParams(window.location.search);
    const searchQuery = searchParams.toString()
      .replace(/\+/g, ' ')  // Replace + with spaces
      .replace(/^=/, '')    // Remove leading = if present
      .toLowerCase();       // Convert to lowercase for comparison

    if (searchQuery) {
      this.init(searchQuery);
    }
  }

  init(searchQuery) {
    // Wait for any dynamic content to load
    this.waitForProducts().then(() => {
      this.reorderProducts(searchQuery);
    });
  }

  waitForProducts() {
    return new Promise(resolve => {
      if (this.productGrid.children.length > 0) {
        resolve();
        return;
      }

      const observer = new MutationObserver((mutations, obs) => {
        if (this.productGrid.children.length > 0) {
          obs.disconnect();
          resolve();
        }
      });

      observer.observe(this.productGrid, {
        childList: true,
        subtree: true
      });
    });
  }

  reorderProducts(searchQuery) {
    const productItems = Array.from(this.productGrid.querySelectorAll('.data-pagination__item'));
    if (productItems.length === 0) return;

    const sortedProducts = productItems.sort((a, b) => {
      const scoreA = this.getRelevanceScore(a, searchQuery);
      const scoreB = this.getRelevanceScore(b, searchQuery);
      return scoreB - scoreA;
    });

    // Reorder products while preserving promotion cards
    sortedProducts.forEach(product => {
      const previousSibling = product.previousElementSibling;
      if (previousSibling && !previousSibling.classList.contains('data-pagination__item')) {
        // If there's a promotion card before the product, maintain that order
        previousSibling.after(product);
      } else {
        this.productGrid.appendChild(product);
      }
    });
  }

  getRelevanceScore(productElement, searchQuery) {
    // Get product title from the heading element
    const productTitle = Array.from(productElement.querySelectorAll('h3'))
      .map(el => el.textContent.toLowerCase())
      .join(' ');
    
    // Remove special characters and extra spaces
    const normalizedTitle = productTitle.replace(/[^\w\s]/g, '').trim();
    const normalizedQuery = searchQuery.replace(/[^\w\s]/g, '').trim();
    
    // Split into words
    const titleWords = normalizedTitle.split(/\s+/);
    const queryWords = normalizedQuery.split(/\s+/);
    
    let score = 0;
    
    // Check for exact match
    if (normalizedTitle === normalizedQuery) {
      score += 100;
    }
    
    // Check for partial matches
    queryWords.forEach(queryWord => {
      if (normalizedTitle.includes(queryWord)) {
        score += 10;
      }
      
      // Check for word matches
      titleWords.forEach(titleWord => {
        if (titleWord === queryWord) {
          score += 5;
        } else if (titleWord.includes(queryWord) || queryWord.includes(titleWord)) {
          score += 2;
        }
      });
    });
    
    return score;
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ProductGridReorder();
});

// Also initialize when Shopify's section:load event fires
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('product-grid-container')) {
    new ProductGridReorder();
  }
});